import DOMPurify from 'dompurify';

// 任务描述由小程序的富文本编辑器写入，里面可能带 <p>、<img> 等标签。
// 渲染前净化：丢掉 script/事件属性等危险内容，保留排版标签和 img（含 http(s) 外链图片）。
// 这里不覆盖 ALLOWED_URI_REGEXP，保持默认行为 —— 默认已放行 http(s) 外链与相对路径。
export const sanitizeHtml = (html) =>
    DOMPurify.sanitize(html ?? '', {
        ADD_TAGS: ['img'],
        ADD_ATTR: ['src', 'alt', 'width', 'height'],
    });
